import script from "./OptionRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./OptionRow.vue?vue&type=script&lang=ts&setup=true"

import "./OptionRow.vue?vue&type=style&index=0&id=f5c429ca&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4139241753/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5c429ca"]])

export default __exports__